import { useEffect, useState } from "react";
import { api } from "@/lib/api";

/** Photos must be fetched with credentials, so render them from a blob URL. */
export const Photo = ({ path, alt, className, testid }) => {
  const [src, setSrc] = useState("");

  useEffect(() => {
    let url;
    let alive = true;
    api.get(`/files/${path}`, { responseType: "blob" })
      .then(({ data }) => {
        if (!alive) return;
        url = URL.createObjectURL(data);
        setSrc(url);
      })
      .catch(() => {});
    return () => {
      alive = false;
      if (url) URL.revokeObjectURL(url);
    };
  }, [path]);

  if (!src)
    return <div className={`bg-muted animate-pulse ${className}`} data-testid={`${testid}-loading`} />;
  return <img src={src} alt={alt} className={className} data-testid={testid} />;
};
